import { GetComponentStyleFunc } from './types';

export const muiTableCell: GetComponentStyleFunc<'MuiTableCell'> = () => {
  return {
    styleOverrides: {
      root: {
        '&.MuiTableCell-root': {
          fontWeight: 900,
        },
      },
    },
  };
};
